import { BaseEntity } from '../../../../models';
import { TipoClassificacao } from '../../../tipo-classificacao';
import { Classificavel, Classificacao } from '../../../classificacao';

export class ClienteClassificacao implements BaseEntity, Classificavel {
    readonly id: number;
    idCliente: number;
    idTipoClassificacao: number;
    tipoClassificacao: TipoClassificacao;
    idClassificacao: number;
    classificacao: Classificacao;

    /** Se pode editar a classificação */
    canEdit: boolean;
    /** Flag se é obrigatório ou não informar a classificação - Herda a configuração do Grupo de Classificações */
    obrigatorio: boolean;
}
